import { Texture } from "../tree/Texture";
export class DrawingTexture extends Texture {
    constructor() {
        super(...arguments);
        this._drawingFunction = undefined;
        this._canvasWidth = 0;
        this._canvasHeight = 0;
    }
    set drawingFunction(f) {
        this._drawingFunction = f;
        this._changed();
    }
    get drawingFunction() {
        return this._drawingFunction;
    }
    set canvasWidth(v) {
        if (this._canvasWidth !== v) {
            this._canvasWidth = v;
            this._changed();
        }
    }
    set canvasHeight(v) {
        if (this._canvasHeight !== v) {
            this._canvasHeight = v;
            this._changed();
        }
    }
    _getIsValid() {
        return !!this._drawingFunction && this._canvasWidth > 0 && this._canvasHeight > 0;
    }
    _getSourceLoader() {
        return (cb) => {
            const canvas = this.stage.platform.getDrawingCanvas();
            canvas.width = this._canvasWidth;
            canvas.height = this._canvasHeight;
            const context = canvas.getContext("2d");
            context.imageSmoothingEnabled = true;
            let result;
            try {
                result = this._drawingFunction({ context, w: this._canvasWidth, h: this._canvasHeight });
            }
            catch (e) {
                if (e instanceof Error) {
                    cb(e);
                }
                else {
                    cb(new Error("Error while drawing: " + e));
                }
                return;
            }
            const handleResult = (result) => {
                const textureSourceOptions = result;
                textureSourceOptions.source = canvas;
                cb(undefined, textureSourceOptions);
            };
            if (result instanceof Promise) {
                result.then((r) => handleResult(r)).catch((e) => cb(e));
            }
            else {
                handleResult(result);
            }
        };
    }
}
//# sourceMappingURL=DrawingTexture.js.map